import {PlaceOrderComponent} from '../../component/pages/place-order/place-order.component';
import {ConfigurateComponent} from '../../component/pages/place-order/configurate/configurate.component';
import {OrderHistoryComponent} from '../../component/pages/order-history/order-history.component';
import {QuickOrderComponent} from '../../component/pages/quick-order/quick-order.component';
import {TendersComponent} from '../../component/pages/tenders/tenders.component';
import {OrderStatisticsComponent} from '../../component/pages/order-statistics/order-statistics.component';
import {ThanksPageComponent} from '../../component/pages/thanks-page/thanks-page.component';
import { DashboardComponent } from '../../component/pages/dashboard/dashboard.component';
import { ProfileComponent } from '../../component/pages/profile/profile.component';
import { SaveCardGuard } from '../guards/save-card.guard';
import { Routes } from "@angular/router";

export const pageRoutes: Routes = [
  { path: '', redirectTo: 'department', pathMatch: 'full'},
  { path: 'thanks', component: ThanksPageComponent},
  { path: 'department', component: DashboardComponent },
  { path: 'profile', component: ProfileComponent },
  {
    path: 'place-order',
    data: {
      pageTitle: 'Bestelling plaatsen'
    },
    children: [
      {
        path: '',
        component: PlaceOrderComponent,
      },
      {
        path: 'configuration',
        component: ConfigurateComponent,
        data: {
          pageTitle: 'Busconfiguratie'
        },
      },
      {
        path: 'overview/ordered/:value',
        component: OrderStatisticsComponent,
        data: {
          pageTitle: 'Bestelling plaatsen'
        },
      },
    ]
  },
  {
    path: 'order-history',
    data: {
      pageTitle: 'Bestelhistory'
    },
    children: [
      {
        path: '',
        component: OrderHistoryComponent,
      },
      {
        path: ':id',
        component: OrderStatisticsComponent,
        data: {
          pageTitle: 'Bestelling'
        },
      },

    ]
  },
  {
    path: 'bulk-order',
    canActivate: [SaveCardGuard],
    data: {
      pageTitle: 'Bulk bestellen'
    },
    children: [
      {
        path: '',
        component: QuickOrderComponent,
      },
    ]
  },
  {
    path: 'tenders',
    canActivate: [SaveCardGuard],
    data: {
      pageTitle: 'Offertes'
    },
    children: [
      {
        path: '',
        component: TendersComponent,
      },

    ]
  },
  {
    path: 'order-statistics',
    canActivate: [SaveCardGuard],
    data: {
      pageTitle: 'Order statistieken'
    },
    children: [
      {
        path: '',
        component: OrderStatisticsComponent,
      },

    ]
  },
];
